<ng-template #oldUiTemplate>
  <h1 mat-dialog-title class="header">
    {{usageType}} Meter Usage
    <button mat-icon-button class="close" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </h1>

  <div *ngIf="spin && !viewUsage" class="spinner-wrapper">
    <mat-spinner [diameter]="70"></mat-spinner>
  </div>

  <ng-container *ngIf="!viewUsage && !spin">
    <div><button mat-button (click)="showUsage('Electric')">View/Upload Electric Meter Usage</button></div>
    <div><button mat-button (click)="showUsage('Gas')">View/Upload Gas Meter Usage</button></div>
  </ng-container>

  <div *ngIf="viewUsage" mat-dialog-content class="ud-dialog-content">
    <mat-card>
      <mat-card-content>
        <div *ngIf="spin" class="spinner-wrapper">
          <mat-spinner [diameter]="70"></mat-spinner>
        </div>
        <div *ngIf="!spin && jsonContent.length > 0" class="styled-table-wrap mat-elevation-z8">
          <table class="styled-table">
            <thead class="table-header-color">
              <tr>
                <th>Serial Number</th>
                <th>Period Start</th>
                <th>Read Date</th>
                <th>Usage</th>
                <th>Demand</th>
                <th>Amount</th>
                <th>Usage Type</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let usage of jsonContent">
                <td> {{usage.SerialNo}} </td>
                <td> {{usage.PeriodStart | date:'M/d/yyyy'}}</td>
                <td> {{usage.ReadDate | date:'M/d/yyyy'}} </td>
                <td> {{usage.Usage}} </td>
                <td> {{usage.Demand}} </td>
                <td> {{usage.Amount}} </td>
                <td> {{usage.Type}} </td>
              </tr>
            </tbody>
          </table>
        </div>
        <input *ngIf="!spin" type="file" (change)="handleFiles($event)" name="uploadExcel" />
        <a href="{{templateDownload}}" download>Download Template</a>
      </mat-card-content>

      <mat-card-actions *ngIf="!spin">
        <button (click)="uploadDoc()" class="button-spacing">Upload</button>
        <button (click)="back()">Back</button>
      </mat-card-actions>

    </mat-card>
  </div>
</ng-template>




<!-- new UI design for FEMD and DOM1 -->
<div *ngIf="isFemdDom1; else oldUiTemplate">
  <div class="ud-modal-header">
    <span class="ud-modal-title">{{usageType || 'Meter'}} Usage</span>
    <button mat-icon-button class="ud-close-btn" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div *ngIf="spin && !viewUsage" class="ud-spinner-wrapper">
    <mat-spinner [diameter]="60"></mat-spinner>
  </div>

  <ng-container *ngIf="!viewUsage && !spin">

    <div class="ud-account-card">
      <div class="ud-card-header" *ngIf="providerResource?.AccountStatus">
        <span class="ud-card-heading">Account Details</span>
        <span class="ud-status-badge"
          [ngClass]="providerResource?.AccountStatus === 'A' ? 'ud-status-active' : 'ud-status-inactive'">
          <mat-icon
            [ngClass]="providerResource?.AccountStatus === 'A' ? 'status-active' : 'status-inactive'">circle</mat-icon>
          {{ providerResource?.AccountStatus === 'A' ? 'Active' : 'Inactive' }}
        </span>
      </div>
      <div class="ud-card-header" *ngIf="providerAccountNumber">
        <span class="ud-card-heading">Account Number</span>
        <span class="ud-status-badge">
          {{ providerAccountNumber }}
        </span>
      </div>
      <div class="ud-card-header" *ngIf="providerResource?.AccountType">
        <span class="ud-card-heading">Account Type</span>
        <span class="ud-status-badge">
          {{ providerResource?.AccountType }}
        </span>
      </div>
      <div class="ud-card-header" *ngIf="providerResource?.OPTOUT">
        <span class="ud-card-heading">Opt-Out Status</span>
        <span class="ud-status-badge">
          {{ providerResource?.OPTOUT }}
        </span>
      </div>
    </div>

    <div class="ud-menu-grid">
      <div class="ud-menu-card" (click)="showUsage('Electric')">
        <div class="ud-menu-icon ud-icon">
          <mat-icon>bolt</mat-icon>
        </div>
        <div>
          <div class="ud-menu-label">Electric Usage</div>
          <div class="ud-menu-sub">View & upload meter data</div>
        </div>
      </div>
      <div class="ud-menu-card" (click)="showUsage('Gas')">
        <div class="ud-menu-icon ud-icon">
          <mat-icon>local_fire_department</mat-icon>
        </div>
        <div>
          <div class="ud-menu-label">Gas Usage</div>
          <div class="ud-menu-sub">View & upload meter data</div>
        </div>
      </div>
      <button *ngIf="utilityService.currentUtility?.OfficeId === 'DOM1'" type="button"
        class="ud-refresh-row-card" (click)="refreshUsage()">
        <span class="ud-menu-icon ud-icon">
          <mat-icon>refresh</mat-icon>
        </span>
        <span class="ud-refresh-text">
          <span class="ud-menu-label">Refresh Usage</span>
          <span class="ud-menu-sub">Loads latest usage into account</span>
        </span>
      </button>
    </div>
  </ng-container>

  <div *ngIf="viewUsage" mat-dialog-content class="ud-dialog-content">
    <div class="ud-section-header">
      <!-- <button class="ud-back-btn" (click)="back()">← Back</button> -->
      <span class="ud-section-title">{{usageType}} Meter Usage</span>
      <button *ngIf="usageType === 'Electric'" mat-flat-button color="primary" class="ud-export-btn"
        (click)="exportCurrentUsageToExcel()">
        <mat-icon>download</mat-icon>
        Export
      </button>
    </div>

    <div *ngIf="spin" class="ud-spinner-wrapper">
      <mat-spinner [diameter]="60"></mat-spinner>
    </div>

    <div *ngIf="!spin && jsonContent.length > 0" class="ud-table-wrap">
      <table class="ud-table">
        <thead>
          <tr>
            <th>Serial No.</th>
            <th>Period Start</th>
            <th>Read Date</th>
            <th>Usage</th>
            <th>Demand</th>
            <th>Amount</th>
            <th>Type</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let usage of jsonContent">
            <td>{{usage.SerialNo}}</td>
            <td>{{usage.PeriodStart | date:'M/d/yyyy'}}</td>
            <td>{{usage.ReadDate | date:'M/d/yyyy'}}</td>
            <td>{{usage.Usage}}</td>
            <td>{{usage.Demand}}</td>
            <td>{{usage.Amount}}</td>
            <td>{{usage.Type}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="!spin" class="ud-upload-row">
      <label class="ud-file-label">
        <mat-icon>attach_file</mat-icon>
        <span>Choose File</span>
        <input type="file" (change)="handleFiles($event)" name="uploadExcel" style="display:none" />
      </label>
      <a class="ud-template-link" href="{{templateDownload}}" download>
        <mat-icon>download</mat-icon>
        <span>Download Template</span>
      </a>
    </div>

    <div *ngIf="!spin" class="ud-actions">
      <button class="ud-btn-primary" (click)="uploadDoc()">Upload</button>
      <button class="ud-btn-secondary" (click)="back()">Back</button>
    </div>
  </div>
</div>